import { ServiceResultWith } from 'schemas/ServiceResultSchema'
import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import VerifiedUsers from 'enums/VerifiedUsers'

const retrieveDocument = (data: ServiceResultWith<DocumentRetrievalResult>[]) =>
  data?.[0]?.results?.[0]?.data?.documents?.[0]

// eslint-disable-next-line import/prefer-default-export
export const retrieveDocumentMetadata = (data: ServiceResultWith<DocumentRetrievalResult>[]) => {
  const document = retrieveDocument(data)
  if (!document) {
    return {}
  }
  return {
    postType: document.properties?.postType,
    dataStream: document.properties?.dataStreams?.[0],
    authorName: document.properties.authorName,
    authorHandle: document.authorHandle,
    authorAvatarUrl: document.properties.authorAvatarUrl,
    authorUrl: document.properties.authorLink,
    authorVerified: document.properties.authorAccountStatus === VerifiedUsers.VERIFIED,
    originalAuthorName: document.properties.originalAuthorName,
    originalAuthorHandle: document.originalAuthorHandle,
    originalAuthorAvatarUrl: document.properties.originalAuthorAvatarUrl,
    originalAuthorUrl: document.properties.originalAuthorUrl,
    originalAuthorVerified:
      document.properties.originalAuthorAccountStatus === VerifiedUsers.VERIFIED,
    datetime: document.properties.datetime,
    url: document.properties.url,
    domain: document.properties.domain
  }
}
